import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAtomValue } from 'jotai'
import { AuthContext } from '../context/firebase-context'
import { projectsStore } from '../AppJotaiStores'
import { activeWorkspace } from '../store/workspace/atoms'
import { applySentryRouteTags, identifySentryUser, isProductionEnvironment, setSentryTriageContext } from '../services/sentry'
import SentryTestTrigger from './SentryTestTrigger'

// Ties every Sentry event to the signed-in user (cleared on logout), their
// plan and workspace, and the feature and ids on screen. Lives inside
// AuthProvider and the router.
export default function SentryBindings () {
  const user = useContext(AuthContext)
  const { pathname } = useLocation()
  // AuthorizedLayout's store, which always loads the active workspace.
  const workspace = useAtomValue(activeWorkspace, { store: projectsStore })
  const [identifiedUuid, setIdentifiedUuid] = useState(null)

  useEffect(() => {
    identifySentryUser(user)
    setIdentifiedUuid(user?.userUuid || user?.uid || null)
  }, [user?.userUuid, user?.email])

  useEffect(() => {
    setSentryTriageContext(user, workspace)
  }, [user, user?.subscriptionPlan, user?.subscriptionStatus, workspace?.uuid, workspace?.type])

  useEffect(() => {
    applySentryRouteTags(pathname)
  }, [pathname])

  if (isProductionEnvironment() || !identifiedUuid) return null
  // Mounts a commit after the effects above (a child's effects run before its parent's),
  // so test events carry the user, plan and route tags.
  return <SentryTestTrigger />
}
